import React from 'react';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const GenerateClaimDialog = ({ open, onClose, onPreview, onConfirm, loading, details }) => {
	return (
		<Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth='sm'>
			<DialogTitle>Review claim generation</DialogTitle>
			<DialogContent>
				<Alert severity='warning' sx={{ mb: 2 }}>
					Confirming creates the claim and links its WorkDone records. Use Preview first if you need to inspect the
					workbook.
				</Alert>
				<Box sx={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 1 }}>
					<strong>Project</strong>
					<span>{details?.projectName || '—'}</span>
					<strong>Client</strong>
					<span>{details?.clientName || '—'}</span>
					<strong>Work period</strong>
					<span>
						{details?.fromDate} to {details?.toDate}
					</span>
					<strong>GST</strong>
					<span>{details?.gstValue}%</span>
				</Box>
				{loading && (
					<Alert severity='info' sx={{ mt: 2 }}>
						Creating the claim and preparing the workbook. Please keep this window open.
					</Alert>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={loading}>
					Cancel
				</Button>
				<Button onClick={onPreview} disabled={loading}>
					Preview workbook
				</Button>
				<Button
					onClick={onConfirm}
					variant='contained'
					disabled={loading}
					startIcon={loading ? <CircularProgress size={18} color='inherit' /> : undefined}>
					{loading ? 'Creating claim…' : 'Create claim'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default GenerateClaimDialog;
